module.exports = __webpack_public_path__ + "img/delivery_large.cb4a79f5.png";